// src/context/DateRangeContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const DateRangeContext = createContext();

export function DateRangeProvider({ children }) {
  const now = new Date();

  const defaultRange = {
    mode: "ytd",
    startDate: new Date(now.getFullYear(), 0, 1),
    endDate: now,
  };

  const [dateRange, setDateRange] = useState(() => {
    const saved = sessionStorage.getItem("dateRange");
    return saved ? JSON.parse(saved) : defaultRange;
  });

  // ✔ 刷新时保留，关闭页面后清空
  useEffect(() => {
    sessionStorage.setItem("dateRange", JSON.stringify(dateRange));
  }, [dateRange]);

  return (
    <DateRangeContext.Provider value={{ dateRange, setDateRange }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export function useDateRange() {
  return useContext(DateRangeContext);
}
